import './Ad_admissions_consultant_viewPic.scss';
import fncS4 from '../../mymod/commFunction4';
import React, { useState, useEffect } from 'react';
import Viewer from 'react-viewer';
// import 'react-viewer/dist/index.css'; ← ❌ 필요 없음

const Ad_admissions_consultant_viewPic = ({ imgUrl, setIsModal }) => {
  const [imgSrc, setImgSrc] = useState(null);
  const [visible, setVisible] = useState(false);
  const [rotation, setRotation] = useState(0); // 회전 각도

  useEffect(() => {
    if (imgUrl) fncLoadImage(imgUrl);
  }, [imgUrl]);

  async function fncLoadImage(imgUrl) {
    const fullPath = await fncS4.getS3PathLong(imgUrl);
    setImgSrc(fullPath);
    setVisible(true);
  }

  // Viewer의 close 버튼 클릭 시 호출되는 이벤트 핸들러
  const handleClose = () => {
    setVisible(false);
    setRotation(0); // 필요하다면 회전 각도도 초기화
    setImgSrc(null);
    setIsModal(false); // 모달 닫기
  };

  //======================================================
  return (
    <div className="Ad_admissions_consultant_viewPic">
      {imgSrc && (
        <Viewer
          visible={visible}
          images={[{ src: imgSrc, alt: '이미지' }]}
        
          rotatable={true} 
          activeIndex={0}
          zIndex={20000}
          attribute={false}//이미지(1440*1080)
          zoomable={true}
          scalable={true}
          changeable={false}
          // downloadable={true}  // ✅ 다운로드 버튼 활성화
          noNavbar={true}
          onClose={handleClose} // Viewer의 close 버튼 클릭 시 호출
          
          // rotate={rotation} // 회전 각도 전달
        />
      )}
    </div>
  );
};

export default Ad_admissions_consultant_viewPic;
